var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _path7, _path8, _path9, _path10, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatistiken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_607_1261",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 16,
    width: 22,
    height: 2
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.479H21.5798V17.1681H0V16.479Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_607_1261)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2626 17.1438H0.316177C0.139706 17.1438 0 17.0051 0 16.8297C0 16.6532 0.139706 16.5156 0.316177 16.5156H21.2626C21.4401 16.5156 21.5788 16.6532 21.5788 16.8297C21.5788 17.0051 21.4401 17.1438 21.2626 17.1438Z",
    fill: "#CD9D41"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_607_1261",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 12,
    width: 5,
    height: 6
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.70093 12.7144H5.19673V17.1681H1.70093V12.7144Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_607_1261)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.67114 17.144C4.49467 17.144 4.35496 17.0054 4.35496 16.8299V13.4392H2.48416V16.8552C2.48416 17.018 2.3455 17.1682 2.16798 17.1682C1.99151 17.1682 1.85181 17.018 1.85181 16.8552V13.1251C1.85181 12.9497 1.99151 12.811 2.16798 12.811H4.67114C4.84866 12.811 4.98731 12.9497 4.98731 13.1251V16.8299C4.97471 17.0054 4.83605 17.144 4.67114 17.144Z",
    fill: "#CD9D41"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_607_1261",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 8,
    width: 5,
    height: 10
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.54541 8.94971H10.0412V17.1682H6.54541V8.94971Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_607_1261)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.58544 17.144C9.40792 17.144 9.26927 17.0053 9.26927 16.8299V9.65974H7.39847V16.8299C7.39847 17.0053 7.25876 17.144 7.08229 17.144C6.90477 17.144 6.76611 17.0053 6.76611 16.8299V9.35827C6.76611 9.19545 6.90477 9.04419 7.08229 9.04419H9.58544C9.76191 9.04419 9.90057 9.19545 9.90057 9.35827V16.8551C9.90057 17.0053 9.76191 17.144 9.58544 17.144Z",
    fill: "#CD9D41"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_607_1261",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 10,
    width: 4,
    height: 8
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6487 10.0251H14.8756V17.168H11.6487V10.0251Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_607_1261)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.495 17.1439C14.3175 17.1439 14.1788 17.0053 14.1788 16.8298V10.8782H12.2954V16.8298C12.2954 17.0053 12.1568 17.1439 11.9793 17.1439C11.8028 17.1439 11.6631 17.0053 11.6631 16.8298V10.5641C11.6631 10.3876 11.8028 10.25 11.9793 10.25H14.495C14.6589 10.25 14.8112 10.3876 14.8112 10.5641V16.8298C14.8112 17.0053 14.6589 17.1439 14.495 17.1439Z",
    fill: "#CD9D41"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_607_1261",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 6,
    width: 4,
    height: 12
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4922 6.2605H19.7191V17.1681H16.4922V6.2605Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_607_1261)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4018 17.1438C19.2254 17.1438 19.0857 17.0051 19.0857 16.8297V6.87174H17.1897V16.8549C17.1897 17.0178 17.051 17.168 16.8735 17.168C16.697 17.168 16.5583 17.0178 16.5583 16.8549V6.58287C16.5583 6.40745 16.697 6.2688 16.8735 6.2688H19.3766C19.5541 6.2688 19.6928 6.40745 19.6928 6.58287V16.8549C19.718 17.0051 19.5794 17.1438 19.4018 17.1438Z",
    fill: "#CD9D41"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.20861 8.39195C4.12038 8.39195 4.03109 8.35413 3.95546 8.2659C3.85462 8.12829 3.89243 7.93922 4.00588 7.82682L7.35567 5.25224C7.49538 5.15245 7.69706 5.18922 7.79895 5.30266C7.89979 5.45287 7.86198 5.64195 7.74853 5.74174L4.39769 8.31632C4.34727 8.36674 4.27164 8.39195 4.20861 8.39195ZM12.299 6.19447C12.2863 6.19447 12.2485 6.19447 12.2359 6.18186L9.24013 5.45287C9.07521 5.41611 8.97437 5.23964 9.01219 5.07682C9.0374 4.92556 9.21492 4.82577 9.37878 4.85098L12.3746 5.59153C12.5269 5.61674 12.6403 5.79216 12.6025 5.95602C12.5521 6.09363 12.425 6.19447 12.299 6.19447ZM14.0059 5.79216C13.9166 5.79216 13.8284 5.75434 13.7527 5.69237C13.6519 5.56632 13.6645 5.36569 13.7906 5.25224L17.1908 2.50224C17.3179 2.40245 17.5195 2.41506 17.634 2.54006C17.7349 2.66611 17.7223 2.86674 17.5952 2.98018L14.195 5.72913C14.1445 5.77955 14.0689 5.79216 14.0059 5.79216Z",
    fill: "#CD9D41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.40955 9.96121C2.70156 9.96121 2.11963 9.38348 2.11963 8.66814C2.11963 7.95175 2.70156 7.37402 3.40955 7.37402C4.13013 7.37402 4.71102 7.95175 4.71102 8.66814C4.71102 9.38348 4.13013 9.96121 3.40955 9.96121ZM3.40955 8.00218C3.04295 8.00218 2.72677 8.30365 2.72677 8.68075C2.72677 9.04419 3.03034 9.35827 3.40955 9.35827C3.80135 9.35827 4.09232 9.0694 4.09232 8.68075C4.11753 8.30365 3.80135 8.00218 3.40955 8.00218Z",
    fill: "#CD9D41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.34127 6.19445C7.62068 6.19445 7.03979 5.61672 7.03979 4.91294C7.03979 4.1976 7.62068 3.61987 8.34127 3.61987C9.06186 3.61987 9.64379 4.1976 9.64379 4.91294C9.64379 5.61672 9.06186 6.19445 8.34127 6.19445ZM8.34127 4.22281C7.94946 4.22281 7.65849 4.52429 7.65849 4.91294C7.65849 5.29004 7.97467 5.59151 8.34127 5.59151C8.70786 5.59151 9.02404 5.29004 9.02404 4.91294C9.02404 4.52429 8.70786 4.22281 8.34127 4.22281Z",
    fill: "#CD9D41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2467 7.41167C12.5261 7.41167 11.9568 6.83393 11.9568 6.1312C11.9568 5.41587 12.5261 4.83813 13.2467 4.83813C13.9673 4.83813 14.5482 5.41587 14.5482 6.1312C14.5482 6.83393 13.9673 7.41167 13.2467 7.41167ZM13.2467 5.45263C12.8801 5.45263 12.5639 5.7415 12.5639 6.1312C12.5639 6.4957 12.8675 6.80977 13.2467 6.80977C13.6385 6.80977 13.9284 6.5083 13.9284 6.1312C13.9284 5.7541 13.6385 5.45263 13.2467 5.45263Z",
    fill: "#CD9D41"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_607_1261",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 0,
    width: 4,
    height: 4
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7627 0.832031H19.7207V3.57153H16.7627V0.832031Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_607_1261)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1503 3.40661C17.4297 3.40661 16.8604 2.84149 16.8604 2.12615C16.8604 1.40976 17.4297 0.832031 18.1503 0.832031C18.8709 0.832031 19.4517 1.40976 19.4517 2.12615C19.4654 2.84149 18.8709 3.40661 18.1503 3.40661ZM18.1503 1.44758C17.7837 1.44758 17.4675 1.73644 17.4675 2.12615C17.4675 2.5022 17.7711 2.80367 18.1503 2.80367C18.5421 2.80367 18.833 2.4896 18.833 2.12615C18.8583 1.76165 18.5421 1.44758 18.1503 1.44758Z",
    fill: "#CD9D41"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatistiken);
export default __webpack_public_path__ + "static/media/Statistiken.c629fbdd17b021e9d1fe4f13dbc87e9f.svg";
export { ForwardRef as ReactComponent };